import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { EmployeeImportDto, EmployeeImportRequest, UpsertEmployeeImportDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/employees-import`;


export const uploadEmployeesFile = (values: Partial<UpsertEmployeeImportDto>,
                                    source: CancelTokenSource): Promise<Array<EmployeeImportDto>> => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof UpsertEmployeeImportDto];

    if (value) {
      if (typeof value === "number") {
        //@ts-ignore
        value = value.toString();
      }
      //@ts-ignore
      bodyFormData.append(key, value);
    }

  });

  return axios
      .post(`${apiUri}`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
};

export const importEmployees = (
    request: Partial<EmployeeImportRequest>, source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .post(`${apiUri}/import`, request, {cancelToken: source.token})
      .then(response => response.data);
};
